import { JsonViewer } from '@/components/ui/json-viewer';

import { useCallDetail } from '@/context/CallProvider';

export const CallExtractedData = () => {
  const { call: callDetail } = useCallDetail();

  return (
    <div className="relative flex-1 h-full min-h-0">
      <div className="absolute left-0 right-0 bottom-0 h-8 pointer-events-none bg-gradient-to-b from-transparent to-white dark:to-zinc-900 z-10" />
      <div className="flex-1 h-full min-h-0 overflow-y-scroll px-4 pb-16 pt-0">
        <JsonViewer data={callDetail.extracted_data} />
      </div>
    </div>
  );
};
